module.exports = __webpack_public_path__ + "static/media/0005.1a39bc9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0005.mp3
// module id = lXDH
// module chunks = 0